
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as valueh5nMM9nqz8LjkzD7sAHZaqQEipd4yTy1s7P4NxKuM8sMeta } from "/vercel/path0/pages/value.vue?macro=true";
import { default as confirmhy9DGa3G0xlIdbC4mTG_450u3_j0SR_45PjDFjuDBxIs15UMeta } from "/vercel/path0/pages/confirm.vue?macro=true";
import { default as purchase2ns98rxMSuUYhNf1_45YITyvPLW2PZaAegWhtQa8LLNngMeta } from "/vercel/path0/pages/purchase.vue?macro=true";
import { default as registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta } from "/vercel/path0/pages/register.vue?macro=true";
import { default as screenerKmIOnCNhHT2cLEt_452lyRkJOE6aNWmv7b_45w9cc_z6vqUMeta } from "/vercel/path0/pages/screener.vue?macro=true";
import { default as fiscal65Xg2j48G0_45SIdVGCi2nR7uC6bYfISpMqnjIqAz_ERQMeta } from "/vercel/path0/pages/settings/fiscal.vue?macro=true";
import { default as accountEOp_OJYBFapRgWkIWTEXDw01fcew97C9tB_45G04bOcjcMeta } from "/vercel/path0/pages/settings/account.vue?macro=true";
import { default as import_45databKXVccb288q70rpb4yQ5PcRUH_45GAz1zBnw0br9OEK5AMeta } from "/vercel/path0/pages/settings/import-data.vue?macro=true";
import { default as settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta } from "/vercel/path0/pages/settings.vue?macro=true";
import { default as benchmarkneudZZ4pvCv0TMWWsxu_45P77aaUSYNbZig9vRIaw0QKgMeta } from "/vercel/path0/pages/benchmark.vue?macro=true";
import { default as dividendso6KkucjALn8ZHMovRaiE2M7W7K0xWy0VWcCeUh0uTZAMeta } from "/vercel/path0/pages/dividends.vue?macro=true";
import { default as portfolio3D3BDUOiCJuBnZIcEsLjaeE5x6Arw_c5PKKj1jhjIGQMeta } from "/vercel/path0/pages/portfolio.vue?macro=true";
import { default as calculatorMpz4GOPbRxYJ_45RO3kDV6tnr8hSlpH1uED9iPrhBwirgMeta } from "/vercel/path0/pages/calculator.vue?macro=true";
import { default as index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta } from "/vercel/path0/pages/admin/index.vue?macro=true";
import { default as unsubscribedPfgzgs3UhF28N7juWnvfGgkfymyuDT_FeYwSDmMKEYAMeta } from "/vercel/path0/pages/unsubscribed.vue?macro=true";
import { default as portfolio_45newoO6Agj5Q2s8f73o_45WO5Zwmrl7rLG9AxgGRXzrK5X_14Meta } from "/vercel/path0/pages/portfolio-new.vue?macro=true";
import { default as password_45reseth3sJlq_02LH1wXudGLM176YWHhy3RbZ5GjcvA8t_45kPMMeta } from "/vercel/path0/pages/password-reset.vue?macro=true";
import { default as benchmarkd4aXt7ZxIz9J0RRhA4CM_45pNO2xztF9yyzwjSmOAE2LIMeta } from "/vercel/path0/pages/public/benchmark.vue?macro=true";
import { default as calculator6GSNmjkp9R2QxhzuraTFahPAuXJIRVDQRdWqN0QM7RsMeta } from "/vercel/path0/pages/tools/calculator.vue?macro=true";
import { default as calculatorV3P1Bu5OEXmKcup_zifhy9kaZAy86NI52BuxibYZNQMMeta } from "/vercel/path0/pages/public/calculator.vue?macro=true";
import { default as _91stockMetricId_93cy9lFcCVEYlSmpH0tO0QLDS5ypETpG42Ki0HqqMkUpcMeta } from "/vercel/path0/pages/company/[stockMetricId].vue?macro=true";
import { default as _91stockMetricId_93amEn8TB99OKHGD3ucuf2tzivqgrA2nEAVgzX4Dcw3DgMeta } from "/vercel/path0/pages/public/company/[stockMetricId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "value",
    path: "/value",
    meta: valueh5nMM9nqz8LjkzD7sAHZaqQEipd4yTy1s7P4NxKuM8sMeta || {},
    component: () => import("/vercel/path0/pages/value.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    meta: confirmhy9DGa3G0xlIdbC4mTG_450u3_j0SR_45PjDFjuDBxIs15UMeta || {},
    component: () => import("/vercel/path0/pages/confirm.vue")
  },
  {
    name: "purchase",
    path: "/purchase",
    meta: purchase2ns98rxMSuUYhNf1_45YITyvPLW2PZaAegWhtQa8LLNngMeta || {},
    component: () => import("/vercel/path0/pages/purchase.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta || {},
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "screener",
    path: "/screener",
    meta: screenerKmIOnCNhHT2cLEt_452lyRkJOE6aNWmv7b_45w9cc_z6vqUMeta || {},
    component: () => import("/vercel/path0/pages/screener.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta || {},
    component: () => import("/vercel/path0/pages/settings.vue"),
    children: [
  {
    name: "settings-fiscal",
    path: "fiscal",
    component: () => import("/vercel/path0/pages/settings/fiscal.vue")
  },
  {
    name: "settings-account",
    path: "account",
    component: () => import("/vercel/path0/pages/settings/account.vue")
  },
  {
    name: "settings-import-data",
    path: "import-data",
    component: () => import("/vercel/path0/pages/settings/import-data.vue")
  }
]
  },
  {
    name: "benchmark",
    path: "/benchmark",
    meta: benchmarkneudZZ4pvCv0TMWWsxu_45P77aaUSYNbZig9vRIaw0QKgMeta || {},
    component: () => import("/vercel/path0/pages/benchmark.vue")
  },
  {
    name: "dividends",
    path: "/dividends",
    meta: dividendso6KkucjALn8ZHMovRaiE2M7W7K0xWy0VWcCeUh0uTZAMeta || {},
    component: () => import("/vercel/path0/pages/dividends.vue")
  },
  {
    name: "portfolio",
    path: "/portfolio",
    meta: portfolio3D3BDUOiCJuBnZIcEsLjaeE5x6Arw_c5PKKj1jhjIGQMeta || {},
    component: () => import("/vercel/path0/pages/portfolio.vue")
  },
  {
    name: "calculator",
    path: "/calculator",
    meta: calculatorMpz4GOPbRxYJ_45RO3kDV6tnr8hSlpH1uED9iPrhBwirgMeta || {},
    component: () => import("/vercel/path0/pages/calculator.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta || {},
    component: () => import("/vercel/path0/pages/admin/index.vue")
  },
  {
    name: "unsubscribed",
    path: "/unsubscribed",
    meta: unsubscribedPfgzgs3UhF28N7juWnvfGgkfymyuDT_FeYwSDmMKEYAMeta || {},
    component: () => import("/vercel/path0/pages/unsubscribed.vue")
  },
  {
    name: "portfolio-new",
    path: "/portfolio-new",
    meta: portfolio_45newoO6Agj5Q2s8f73o_45WO5Zwmrl7rLG9AxgGRXzrK5X_14Meta || {},
    component: () => import("/vercel/path0/pages/portfolio-new.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: password_45reseth3sJlq_02LH1wXudGLM176YWHhy3RbZ5GjcvA8t_45kPMMeta || {},
    component: () => import("/vercel/path0/pages/password-reset.vue")
  },
  {
    name: "public-benchmark",
    path: "/public/benchmark",
    meta: benchmarkd4aXt7ZxIz9J0RRhA4CM_45pNO2xztF9yyzwjSmOAE2LIMeta || {},
    component: () => import("/vercel/path0/pages/public/benchmark.vue")
  },
  {
    name: "tools-calculator",
    path: "/tools/calculator",
    meta: calculator6GSNmjkp9R2QxhzuraTFahPAuXJIRVDQRdWqN0QM7RsMeta || {},
    component: () => import("/vercel/path0/pages/tools/calculator.vue")
  },
  {
    name: "public-calculator",
    path: "/public/calculator",
    meta: calculatorV3P1Bu5OEXmKcup_zifhy9kaZAy86NI52BuxibYZNQMMeta || {},
    component: () => import("/vercel/path0/pages/public/calculator.vue")
  },
  {
    name: "company-stockMetricId",
    path: "/company/:stockMetricId()",
    meta: _91stockMetricId_93cy9lFcCVEYlSmpH0tO0QLDS5ypETpG42Ki0HqqMkUpcMeta || {},
    component: () => import("/vercel/path0/pages/company/[stockMetricId].vue")
  },
  {
    name: "public-company-stockMetricId",
    path: "/public/company/:stockMetricId()",
    meta: _91stockMetricId_93amEn8TB99OKHGD3ucuf2tzivqgrA2nEAVgzX4Dcw3DgMeta || {},
    component: () => import("/vercel/path0/pages/public/company/[stockMetricId].vue")
  }
]